import React from 'react';
import ReactSelect from 'react-select';
import 'react-select/less/select.less';
import axios from 'axios';
import classnames from 'classnames';


export default class TeamSelect extends React.Component {

  static propTypes = {
    round: React.PropTypes.number.isRequired
  };

  getTeams(q, callback) {
    const exclude = this.props.exclude;
    axios.get('/admin/pointblank/singleround/find_teams/', {params: {q, round: this.props.round}})
    .then(function(response) {
      callback(null, {
        options: [
          for (team of response.data)
          if (!exclude.contains(team.id))
          {value: team.id.toString(), label: team.title, team}
        ]
      });
    })
    .catch(function(err) {
      callback(err);
    });
  }

  onChange(_, teams) {
    if (teams && teams[0]) {
      this.props.onSelect(teams[0].team);
    }
  }

  render() {
    const className = classnames(
      'TeamSelect',
      this.props.disabled && 'TeamSelect--disabled'
    );
    return (
      <div className={className}>
        <ReactSelect ref='select'
                     value={null}
                     onChange={this.onChange.bind(this)}
                     asyncOptions={this.getTeams.bind(this)}
                     cacheAsyncResults={false}
                     placeholder='Select team'/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/TeamSelect.js